import React, { useEffect, useState } from 'react';
import GlobalStore from '../../stores/global-store';
import urlsApi from '../../apis/urls-api';
import './Url.css';
import getAffiliateId from '../../utils/get_affiliate_id';

function Url() {
  const affiliate_id = getAffiliateId();
  const {setLoading, affID} = GlobalStore.useContainer();
  const [url, setUrl] = useState('');
  const [campaign, setCampaign] = useState('');
  var [link, setLink] = useState(url + '?ref=' + affiliate_id);

  useEffect(() => {
    async function getUrls() {
      setLoading(true);
      const responseUrls = await urlsApi.getUrls(affID);
      setUrl(responseUrls.data.urls);
      setLoading(false);
    }
    getUrls();
  }, [setLoading]);

  useEffect(() => {
    if (campaign.trim() !== '') {
      setLink(url + '?campaign=' + campaign + '&ref=' + affiliate_id);
    } else {
      setLink(url + '?ref=' + affiliate_id);
    }
  }, [campaign, url, affiliate_id]);

  const handleUrl = (e) => {
    if (e.target.value.trim() !== '') {
      setUrl(e.target.value);
    }
  }

  const handleCampaign = (e) => {
    setCampaign(e.target.value);
  };

  const copyLink = async (e) => {
    var link = document.getElementsByClassName('link')
    await navigator.clipboard.writeText(link[e.target.getAttribute('index')]?.textContent || '');
    e.target.innerHTML = 'Copied';
  };

  return (
    <div className="referral-url container-fluid">
      <div className="header">
        <h1>Link giới thiệu</h1>
      </div>
      {url && url !== 'none' && (
        <div className="body">
          <div className="section1 row">
            <div className="col-lg-4 col-left">
              <h3 className="title">Link Giới Thiệu</h3>
              <p className="sub-title text--grey">Chia sẻ link giới thiệu của bạn đến khách hàng để nhận hoa hồng. </p>
            </div>
            <div className="col-lg-8 col-right">
              <div className="box">
                <div className="border-input">
                  <div className="link-wrap">
                    <svg className="referral-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
                    <span className="text text--grey link"> https://vn.elsaspeak.com/affiliates-vnaff/ </span>
                  </div>
                  <span className="copy-link" index="0" onClick={copyLink}>Copy link</span>
                </div>
              </div>
            </div>
          </div>

          <div className="break-line"></div>

          <div className="section1 row">
            <div className="col-lg-4 col-left">
              <h3 className="title">Công Cụ Tạo Link Giới Thiệu</h3>
              <p className="sub-title text--grey">Điền thông tin vào công cụ này để tạo link giới thiệu cụ thể.</p>
            </div>
            <div className="col-lg-8 col-right">
              <div className="box">
                <div className="item">
                  <h2 className="title mb-2">Địa Chỉ Trang Cần Giới Thiệu</h2>
                  <div>
                    <input type="text" className="text border-input" onChange={handleUrl} value={url} />
                  </div>
                </div>
                <div className="item">
                  <h2 className="title">Tên Chiến Dịch</h2>
                  <p className="sub-title text--grey">Điền tên chiến dịch để theo dõi nguồn chuyển đổi.</p>
                  <div>
                    <input type="text" className="text border-input" onChange={handleCampaign} value={campaign} />
                  </div>
                </div>
                <div className="item">
                  <h2 className="title">Link Giới Thiệu Được Tạo</h2>
                  <p className="sub-title text--grey">Chia sẻ link giới thiệu này đến khách hàng của bạn.</p>
                  <div className="border-input">
                    <div className="link-wrap">
                      <svg className="referral-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path></svg>
                      <span className="text link">{link}</span>
                    </div>
                    <span className="copy-link" index="1" onClick={copyLink}>Copy link</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {url === 'none' && (
        <h4 className="alert alert-info">Link giới thiệu sẽ được sẵn sàng khi hợp đồng được ký kết thành công</h4>
      )}
    </div>
  );
}

export default Url;
